import { render, staticRenderFns } from "./AdditionalBlockActions.vue?vue&type=template&id=2f6dfc16&scoped=true"
import script from "./AdditionalBlockActions.vue?vue&type=script&lang=js"
export * from "./AdditionalBlockActions.vue?vue&type=script&lang=js"
import style0 from "./AdditionalBlockActions.vue?vue&type=style&index=0&id=2f6dfc16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6dfc16",
  null
  
)

export default component.exports